export default __webpack_public_path__ + "static/media/icon-question-outline-red.d0b2c69f.svg";